import React, { useMemo } from 'react';
import Barcode from 'react-barcode';
import { Typography } from 'fronton-react';
import { KeycardFooter, KeycardHeader, KeycardWrapper } from './styles';
import { useWindowSize } from 'fronton-react/hooks/use-window-size';
import { EKeycardType } from 'reducers/loyalty-registration-modal-reducer';
import { useBreakpoints } from 'common/hooks';
import { formatCardNumber } from '../../../utils/format-card-number';
import { KeycardKey } from '../../icons/keycard-key';
import { useTranslation } from 'react-i18next';

interface IKeycard {
  cardNumber: string;
  keycardType: EKeycardType;
}

export const Keycard: React.FC<IKeycard> = ({ cardNumber, keycardType }) => {
  const { t } = useTranslation();
  const { mobile } = useBreakpoints() || {};
  const proCard = keycardType === EKeycardType.PRO;
  const { innerWidth } = useWindowSize();

  const barcodeWidth: number = useMemo(() => {
    if (innerWidth <= 330) {
      return 1.8;
    }

    if (innerWidth <= 350) {
      return 1.9;
    }

    if (innerWidth <= 370) {
      return 2.0;
    }

    if (innerWidth <= 390) {
      return 2.2;
    }

    return 1.8;
  }, [innerWidth]);

  return (
    <KeycardWrapper data-qa={`keycard-${keycardType}`}>
      <KeycardHeader pro={proCard}>
        <Typography variant="m" size="body_accent" color={proCard ? 'text-primary-invert' : 'text-primary'}>
          {t(`loyalty-registration-modal.success-step.${keycardType}`)}
        </Typography>
        <KeycardKey />
      </KeycardHeader>
      <KeycardFooter>
        <Barcode
          width={barcodeWidth}
          value={cardNumber}
          displayValue={false}
          height={mobile ? 108 : 40}
          margin={0}
        />
        <Typography variant="m" size="body_long">
          {formatCardNumber(cardNumber)}
        </Typography>
      </KeycardFooter>
    </KeycardWrapper>
  );
};
